// extracted by mini-css-extract-plugin
module.exports = {"small":"Spacer_small__QIkiD","medium":"Spacer_medium__3wUGn","large":"Spacer_large__1pDrI"};